import React from "react";
import { useSelector } from "react-redux";
import GuestRequest_Potrait from "./guestRequest_potrait";
import { LANDSCAPE } from "../../../config/Constant";
import GuestRequest_Landscape from "./guestRequest_landscape";


export const GuestRequest = (props) => {
    const { appOrientation } = useSelector(state => (state.appConfigSlice));

    if (appOrientation == LANDSCAPE) {
        return <GuestRequest_Landscape {...props} />;
    } else {
        return <GuestRequest_Potrait {...props} />;
    }
}